// @codekit-prepend "extern/jquery.fancybox.js"
// @codekit-prepend "extern/swiper-min.js"

// @codekit-prepend "modules/cookie.js"

//Touch sniffer
if ('ontouchstart' in document.documentElement) {
	document.querySelector('html').classList.add('is-touch');
}

const $hamburger = document.querySelectorAll('.site-hamburger');

[...$hamburger].forEach(($h) => {
	$h.addEventListener('click', (e) => {
		e.currentTarget.closest('.site-header').classList.toggle('menu-is-open');
	});
});

const nav = document.querySelector('.site-header[data-nav="scroll"]');

function showNav() {
	if (window.scrollY >= 320) {
		document.body.classList.add('nav-is-visible');
	} else {
		document.body.classList.remove('nav-is-visible');
	}
}

if (document.body.classList.contains('home')) {
	window.addEventListener('scroll', showNav);
}

const inspirationSwiper = new Swiper('.inspiration-slider', {
	slidesPerView: 1,
	spaceBetween: 0,
	speed: 0,
	//effect: 'fade',
	loop: false,
	navigation: {
		nextEl: '[data-pager="inspiration"] .button-next',
		prevEl: '[data-pager="inspiration"] .button-prev'
	}
});

const customerSwiper = new Swiper('.customer-slider', {
	slidesPerView: 5,
	spaceBetween: 50,
	speed: 250,
	loop: false,
	navigation: {
		nextEl: '[data-pager="customer"] .button-next',
		prevEl: '[data-pager="customer"] .button-prev'
	},
	breakpoints: {
		540: {
			slidesPerView: 2
		},
		768: {
			slidesPerView: 3
		},
		1024: {
			slidesPerView: 4
		}
	}
});

const filter = document.querySelector('#locations');
const items = document.querySelectorAll('.customer-slider .swiper-slide');
let currentActive = '';

filter && filter.addEventListener('change', toggleItems);

function handleFilter(e) {
	toggleItems(e.currentTarget);
}

function toggleItems(e) {
	currentActive = e.target.value;

	//removeActive( '.customer-slider .swiper-slide[data-active]' );

	items.forEach((item) => {
		if (item.dataset.location === currentActive) {
			item.setAttribute('data-active', '');
		} else {
			item.removeAttribute('data-active');
		}
	});

	customerSwiper.update();
}

const removeActive = function (selector) {
	document.querySelectorAll(selector).forEach((el) => delete el.dataset.active);
};

jQuery(document).ready(function ($) {
	// SCROLL FUNCTIES ++++++++++++++++++++++++++ //

	// Back to top -----------
	$('.backtotop').click(function () {
		$('html, body').animate({ scrollTop: 0 }, 600);
		return false;
	});

	$(window).scroll(function () {
		var scroll = $(window).scrollTop();
		if ($(window).scrollTop() > 400) {
			$('.backtotop').addClass('toon');
		} else if ($(window).scrollTop() <= 400) {
			$('.backtotop').removeClass('toon');
		}
	});

	$(window).scroll(function () {
		if ($(window).scrollTop() + $(window).height() == $(document).height()) {
			$('.backtotop').addClass('fix');
		} else {
			$('.backtotop').removeClass('fix');
		}
	});

	// Assumes that you're using jQuery and Bootstrap
	// The `ajaxurl` variable, should be declared in
	// header.php like so:
	// ajaxurl = '<?php echo admin_url('admin-ajax.php'); ?>';

	var $modal = $('#modal');
	var $modal_target = $('[data-modal="target"]');

	$('.inspiration, .inspiration-list').on('click', 'a.card', function (e) {
		e.preventDefault();

		var id = $(this).data('id');

		$.ajax({
			url: xpl.ajaxurl,
			data: {
				action: 'fetch_modal_content',
				id: id
			},
			success: function (data) {
				$modal_target.html(data);
				$modal.modal('show');
			}
		});
	});
});
